var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseMedicalCircleCheckSolid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 100,
    viewBox: "0 0 125 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 71.875C62.5 83.4961 68.2617 93.7695 77.1094 100H25.0195C18.125 100 12.5195 94.3945 12.5195 87.5V56.1719H6.25C2.73438 56.1719 0 53.4375 0 49.9023C0 48.1445 0.585938 46.582 1.95312 45.2148L52.0312 1.5625C53.3984 0.195312 54.9609 0 56.3281 0C57.6953 0 59.2578 0.390625 60.4297 1.36719L101.973 37.8711C100.312 37.6172 98.5938 37.5 96.875 37.5C86.1914 37.5 76.6602 42.3633 70.3516 50H62.5V40.625C62.5 38.9062 61.0938 37.5 59.375 37.5H53.125C51.4062 37.5 50 38.9062 50 40.625V50H40.625C38.9062 50 37.5 51.4062 37.5 53.125V59.375C37.5 61.0938 38.9062 62.5 40.625 62.5H50V71.875C50 73.5938 51.4062 75 53.125 75H59.375C61.0938 75 62.5 73.5938 62.5 71.875ZM68.75 71.875C68.75 64.4158 71.7132 57.2621 76.9876 51.9876C82.2621 46.7132 89.4158 43.75 96.875 43.75C104.334 43.75 111.488 46.7132 116.762 51.9876C122.037 57.2621 125 64.4158 125 71.875C125 79.3342 122.037 86.4879 116.762 91.7624C111.488 97.0368 104.334 100 96.875 100C89.4158 100 82.2621 97.0368 76.9876 91.7624C71.7132 86.4879 68.75 79.3342 68.75 71.875ZM110.02 63.418C108.809 62.207 106.816 62.207 105.605 63.418L93.75 75.2734L88.1445 69.668C86.9336 68.457 84.9414 68.457 83.7305 69.668C82.5195 70.8789 82.5195 72.8711 83.7305 74.082L91.543 81.8945C92.7539 83.1055 94.7461 83.1055 95.957 81.8945L110.02 67.832C111.23 66.6211 111.23 64.6289 110.02 63.418Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseMedicalCircleCheckSolid2);
export default __webpack_public_path__ + "static/media/house-medical-circle-check-solid 2.abdc4c6565dc20ea6cc316b4199f2dc9.svg";
export { ForwardRef as ReactComponent };